import { render, staticRenderFns } from "./InfocardTransportVehiclePicker.vue?vue&type=template&id=b4c3dd46&"
import script from "./InfocardTransportVehiclePicker.vue?vue&type=script&lang=js&"
export * from "./InfocardTransportVehiclePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports